'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _notification = require('../notification');

var _notification2 = _interopRequireDefault(_notification);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _input = require('../input');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var ActionButton = function ActionButton(_ref) {
  var children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === undefined ? 'primary' : _ref$appearance,
      _ref$meta = _ref.meta,
      meta = _ref$meta === undefined ? {
    touched: false,
    error: null
  } : _ref$meta,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      extraLabel = _ref.extraLabel,
      icon = _ref.icon,
      onClick = _ref.onClick;
  var isFilled = appearance === 'filled';
  return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(isFilled ? 'div' : 'button', {
    className: cx('xsui-action-button', 'xsui-action-button--appearance-' + appearance, disabled && 'xsui-action-button--disabled', meta.touched && meta.error && 'xsui-action-button--error'),
    type: 'button',
    onClick: isFilled ? function () {
      return void 0;
    } : onClick,
    children: _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
      className: cx('xsui-action-button__entry')
    }, children), _react2.default.createElement('div', {
      className: cx('xsui-action-button__right')
    }, extraLabel && _react2.default.createElement('div', {
      className: cx('xsui-action-button__extra')
    }, extraLabel), icon && _react2.default.createElement('div', {
      className: cx('xsui-action-button__icon')
    }, _react2.default.createElement(_icon2.default, {
      name: icon,
      hoverable: true,
      onClick: isFilled ? onClick : function () {
        return void 0;
      }
    }))))
  }), meta.touched && meta.error && _react2.default.createElement(_notification2.default, {
    appearance: 'string',
    status: 'error'
  }, meta.error));
};

ActionButton.propTypes = {
  children: function children() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  appearance: _propTypes2.default.oneOf(['primary', 'filled']),
  meta: function meta() {
    return (typeof _input.bpfrpt_proptype_Meta === 'function' ? _input.bpfrpt_proptype_Meta : _propTypes2.default.shape(_input.bpfrpt_proptype_Meta)).apply(this, arguments);
  },
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  extraLabel: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
exports.default = ActionButton;